import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import {
  setHomeServices,
  setHomeStaff,
  setHomeDateNow,
  setHomeLoading,
  setHomeLoaded,
} from "../../../redux/action/user/appointments/action";
import { SET_ACCESS_TOKEN } from "../../../redux/action/auth/type";
import AddAppointmentContentStep1 from "./FirstStep/indesx";
import AddAppointmentContentStep2 from "./Step2";
import useAxiosAdmin from "../../Admin/lib/axiosAdmin";

const BASE_URL = "https://my-sarad-back.liara.run";

const AddAppointmentContent = () => {

  const axiosAdmin = useAxiosAdmin()

  const dispatch = useDispatch();
  const [cookies] = useCookies(["refreshToken"]);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const { homeLoaded, homeLoading, services, staff, dateNowServer } =
    useSelector((state) => state.userAppointments);

  const [selectedService, setSelectedService] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);

  const [internalSelectedDateNormal, setInternalSelectedDateNormal] = useState();
  const [selectedTimeNormal, setSelectedTimeNormal] = useState();
  const [selectedStaffNormal, setSelectedStaffNormal] = useState(null);
  const [nowDate, setNowDate] = useState()
  
  const [internalSelectedDateVip, setInternalSelectedDateVip] = useState();
  const [selectedTimeVip, setSelectedTimeVip] = useState();


  const [step, setStep] = useState(1);
  const [showRules, setShowRules] = useState(false);

  // stateهای مربوط به درخواست availability
  const [availabilityData, setAvailabilityData] = useState(null);
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [availabilityError, setAvailabilityError] = useState("");

  const [paymentLoading, setPaymentLoading] = useState(false);

  const [step2Data, setStep2Data] = useState({ date: null, time: null, staff: null, isComplete: false });

     const handleStep2DataChange = (data) => {
     setStep2Data(data);
   };

  // fetchHomeData مثل قبل ...
  const fetchHomeData = async () => {
    dispatch(setHomeLoading(true));
    try {
      const { data } = await axios.get(`${BASE_URL}/api/user/home`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      dispatch(setHomeServices(data.services));
      dispatch(setHomeStaff(data.staff));
      dispatch(setHomeDateNow(data.dateNowServer));
      dispatch(setHomeLoaded(true));
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const refreshRes = await axios.post(
            `${BASE_URL}/api/auth/refresh-token`,
            { refreshToken: cookies.refreshToken }
          );
          const newAccess = refreshRes.data.accessToken;
          dispatch({ type: SET_ACCESS_TOKEN, payload: newAccess });
          const retryRes = await axios.get(`${BASE_URL}/api/user/home`, {
            headers: { Authorization: `Bearer ${newAccess}` },
          });
          dispatch(setHomeServices(retryRes.data.services));
          dispatch(setHomeStaff(retryRes.data.staff));
          dispatch(setHomeDateNow(retryRes.data.dateNowServer));
          dispatch(setHomeLoaded(true));
        } catch (refreshError) {
          toast.error("نشست شما منقضی شده است، لطفا دوباره وارد شوید");
          dispatch(setHomeLoaded(true));
        }
      } else {
        toast.error("خطا در دریافت اطلاعات اولیه");
        dispatch(setHomeLoaded(true));
      }
    } finally {
      dispatch(setHomeLoading(false));
    }
  };

  useEffect(() => {
    if (!homeLoaded && !homeLoading) {
      fetchHomeData();
    }
  }, []);

  // ----- تابع کمکی برای درخواست‌های auth دار (با refresh) -----
  const fetchWithAuth = useCallback(
    async ({ method = "post", url, data }) => {
      try {
        const res = await axios({
          method,
          url: `${BASE_URL}${url}`,
          data,
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        return res.data;
      } catch (error) {
        if (error.response?.status === 401) {
          // تلاش برای refresh
          try {
            const refreshRes = await axios.post(
              `${BASE_URL}/api/auth/refresh-token`,
              { refreshToken: cookies.refreshToken }
            );
            const newAccess = refreshRes.data.accessToken;
            dispatch({ type: SET_ACCESS_TOKEN, payload: newAccess });

            // تکرار درخواست اصلی با token جدید
            const retryRes = await axios({
              method,
              url: `${BASE_URL}${url}`,
              data,
              headers: { Authorization: `Bearer ${newAccess}` },
            });
            return retryRes.data;
          } catch (refreshError) {
            toast.error("نشست شما منقضی شده است، لطفا دوباره وارد شوید");
            throw refreshError;
          }
        } else {
          throw error;
        }
      }
    },
    [accessToken, cookies.refreshToken, dispatch]
  );

  // تابع کلیک روی ادامه
  // const handleContinue = async () => {
  //   if (step === 1 && !isCompleteStep1) return;

  //   if (step === 1) {
  //     // فراخوانی API مناسب بر اساس متد انتخاب‌شده
  //     setAvailabilityLoading(true);
  //     setAvailabilityError("");
  //     setAvailabilityData(null);

  //     try {
  //       if (selectedMethod === "vip") {
  //         // VIP
  //         const data = await fetchWithAuth({
  //           url: "/api/user/availability/vip",
  //           data: {
  //             serviceId: selectedService._id,
  //             type: selectedType,
  //             method: "vip",
  //             staffId: selectedStaff._id,
  //             days: 180,
  //           },
  //         });
  //         setAvailabilityData(data);
  //       } else {
  //         // Normal
  //         const data = await fetchWithAuth({
  //           url: "/api/user/availability/normal",
  //           data: {
  //             serviceId: selectedService._id,
  //             type: selectedType,
  //             days: 180,
  //           },
  //         });
  //         setNowDate(data.dateNowServer.serverTime)
  //         setAvailabilityData(data);
  //       }
  //       setStep(2);
  //     } catch (error) {
  //       const message =
  //         error.response?.data?.message || "خطا در بررسی ظرفیت";
  //       setAvailabilityError(message);
  //       toast.error(message);
  //     } finally {
  //       setAvailabilityLoading(false);
  //     }
  //   } else if (step === 2) {
  //     // منطق بعداً اضافه می‌شود
  //     console.log("تایید و ادامه");

  //     console.log('selectedService', selectedService);
  //     console.log('selectedType', selectedType);
  //     console.log('selectedMethod', selectedMethod);
  //     console.log('selectedStaff', selectedStaff);
  //     console.log('internalSelectedDateNormal', internalSelectedDateNormal);
  //     console.log('selectedTimeNormal', selectedTimeNormal);
  //     console.log('selectedStaffNormal', selectedStaffNormal);
      
  //   }
  // };

  const handleContinue = async () => {
  if (step === 1 && !isCompleteStep1) return;

  if (step === 1) {
    // (کد قبلی بدون تغییر)
    setAvailabilityLoading(true);
    setAvailabilityError("");
    setAvailabilityData(null);

    try {
      if (selectedMethod === "vip") {
        const data = await fetchWithAuth({
          url: "/api/user/availability/vip",
          data: {
            serviceId: selectedService._id,
            type: selectedType,
            method: "vip",
            staffId: selectedStaff._id,
            days: 180,
          },
        });
        setAvailabilityData(data);
      } else {
        const data = await fetchWithAuth({
          url: "/api/user/availability/normal",
          data: {
            serviceId: selectedService._id,
            type: selectedType,
            days: 180,
          },
        });
        setNowDate(data.dateNowServer.serverTime);
        setAvailabilityData(data);
      }
      setStep(2);
    } catch (error) {
      const message = error.response?.data?.message || "خطا در بررسی ظرفیت";
      setAvailabilityError(message);
      toast.error(message);
    } finally {
      setAvailabilityLoading(false);
    }
  } else if (step === 2) {
    // ---------- مرحله نهایی: ارسال درخواست پرداخت ----------
    setPaymentLoading(true);
    try {
      // ساخت body بر اساس متد (VIP/عادی)
      const isVip = selectedMethod === "vip";
      const body = {
        serviceId: selectedService._id,
        type: selectedType,
        method: isVip ? "vip" : "عادی",
        paymentType: "زرین پال",
      };

      if (isVip) {
        // اطلاعات VIP
        body.staffId = selectedStaff._id;
        body.date = internalSelectedDateVip.date;  // مثلاً "2026-06-24"
        body.time = selectedTimeVip;               // مثلاً "17:00"
      } else {
        // اطلاعات عادی
        body.staffId = selectedStaffNormal._id;
        body.date = internalSelectedDateNormal.date; // مثلاً "2026-07-05"
        body.time = selectedTimeNormal;              // مثلاً "12:00"
      }

      // اعتبارسنجی (نمونه)
      if (!body.staffId || !body.date || !body.time) {
        throw new Error("اطلاعات ناقص است. لطفاً همه موارد را انتخاب کنید.");
      }

      // ارسال درخواست به سرور
      const result = await fetchWithAuth({
        method: "post",
        url: "/api/payment/request",
        data: body,
      });

      // هدایت به درگاه پرداخت
      if (result.redirectUrl) {
        window.location.href = result.redirectUrl;
      } else {
        toast.error("آدرس پرداخت دریافت نشد");
        setPaymentLoading(false);
      }
    } catch (error) {
      // مدیریت خطاهای دریافتی از سرور یا شبکه
      const message =
        error.response?.data?.message || error.message || "خطا در اتصال به درگاه پرداخت";
      toast.error(message);
      setPaymentLoading(false);
    }
  }
};


  const isCompleteStep1 =
    selectedService &&
    selectedType &&
    selectedMethod &&
    (selectedMethod !== "vip" || selectedStaff);

  if (homeLoading || !homeLoaded) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-purple-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-slate-500">در حال بارگذاری اطلاعات...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto">
      {step === 1 && (
        <AddAppointmentContentStep1
          services={services}
          staff={staff}
          selectedService={selectedService}
          selectedType={selectedType}
          selectedMethod={selectedMethod}
          selectedStaff={selectedStaff}
          setSelectedService={setSelectedService}
          setSelectedType={setSelectedType}
          setSelectedMethod={setSelectedMethod}
          setSelectedStaff={setSelectedStaff}
          isComplete={isCompleteStep1}
          dateNowServer={dateNowServer}
          onComplete={(selections) => {
            console.log("انتخاب‌های کاربر:", selections);
          }}
          showRules={showRules}
          setShowRules={setShowRules}
        />
      )}

      {step === 2 && (
        <>
            <AddAppointmentContentStep2
              method={selectedMethod}
              availabilityData={availabilityData}
              onBack={() => setStep(1)}      // یا هر منطق دیگر
              onContinue={() => {}}           // اختیاری (کنترل از طریق isComplete و دکمه‌ی والد)
              axiosAdmin={axiosAdmin}
              onStepDataChange={handleStep2DataChange}
              serviceId={selectedService?._id}
              type={selectedType}

              internalSelectedDateNormal={internalSelectedDateNormal}
              setInternalSelectedDateNormal={setInternalSelectedDateNormal}
              internalSelectedDateVip={internalSelectedDateVip}
              setInternalSelectedDateVip={setInternalSelectedDateVip}
              selectedTimeVip={selectedTimeVip}
              setSelectedTimeVip={setSelectedTimeVip}


              selectedTimeNormal={selectedTimeNormal}
              setSelectedTimeNormal={setSelectedTimeNormal}
              selectedStaffNormal={selectedStaffNormal}
              setSelectedStaffNormal={setSelectedStaffNormal}

              nowDate={nowDate}
            />
        </>
      )}

      {/* دکمه‌های پایین */}
      <div
        className={`mt-8 flex ${
          step === 1 ? "justify-end" : "justify-between"
        }`}
      >
        {/* بازگشت فقط در استپ ۲ */}
        {step === 2 && (
          <button
            onClick={() => {
              setStep(1)
              setInternalSelectedDateNormal(null)
              setInternalSelectedDateVip(null)
              setSelectedTimeNormal(null)
              setSelectedStaffNormal(null)
              setSelectedTimeVip(null)
            }}
            className="px-5 py-2.5 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors"
            disabled={availabilityLoading}
          >
            بازگشت
          </button>
        )}

        {/* دکمه‌ی ادامه/تایید */}
        <button
          disabled={
            (step === 1 && !isCompleteStep1) ||
            availabilityLoading ||
            paymentLoading
          }
          onClick={handleContinue}
          className="px-6 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 rounded-lg shadow-md shadow-purple-500/25 hover:shadow-lg hover:shadow-purple-500/30 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        >
          {availabilityLoading || paymentLoading ? (
            <>
              <span>در حال بررسی...</span>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            </>
          ) : (
            <>
              <span>{step === 1 ? "ادامه" : "تایید و پرداخت"}</span>
              <span>←</span>
            </>
          )}
        </button>

      </div>
    </div>
  );
};

export default AddAppointmentContent;